<template>
  <div
    v-if="hasExtra"
    :class="{ 'grey--text': !fontColor }"
    :style="fontColor ? { color: fontColor } : {}"
  >
    <template v-for="(item, i) in computeValue">
      <v-row
        v-show="!!item.icon || !!item.value"
        :key="i"
        class="pt-2"
        no-gutters
      >
        <v-col
          :class="{ 'link-tag': extraIsLink(item) }"
          :href="extraIsLink(item) ? fixLink(item.link) : false"
          :tag="extraIsLink(item) ? 'a' : 'div'"
          class="d-flex align-start mb-1"
          cols="12"
          target="_blank"
        >
          <!-- بخش آیکون و دونقطه -->
          <span v-if="item.icon" class="text-no-wrap me-1">
            <v-icon :color="fontColor || undefined">
              {{ item.icon }}
            </v-icon>
            :
          </span>

          <!-- بخش لیبل -->
          <span
            v-else-if="item.label"
            class="text-no-wrap me-2 my-1"
          >
            {{ item.label }}:
          </span>

          <!-- بخش مقدار -->
          <pre
            v-if="item.value || item.link"
            :key="i"
            :class="[
              extraIsLink(item) ? 'link-tag' : '',
              { 'grey--text': !fontColor }
            ]"
            :style="fontColor ? { color: fontColor } : {}"
            class="text-right mt-1 mb-2"
            v-html="item.value || item.link"
          />
        </v-col>

        <v-col v-show="i + 1 < value.length" class="py-2" cols="12">
          <v-divider class="my-0" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: "extraShown",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    hasClass: {
      type: Boolean,
      default: false,
    },
    fontColor: {
      type: String,
      default: null, // یا ''
    },
  },

  computed: {
    hasExtra() {
      return !!this?.value?.filter(
        (item) => !!item?.name || !!item?.icon || !!item?.value
      )?.length;
    },
    computeValue() {
      return this.value;
    },
  },

  methods: {
    extraIsLink(item) {
      return !!(item.link && item.link.length > 0);
    },
    fixLink(link) {
      return link?.startsWith("http") ? link : "https://" + link;
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

a.link-tag {
  color: inherit !important;
  text-decoration: none;
}
</style>
